export default [
  {
    path: "/pais",
    name: "Pais",
    component: () =>
      import(/* webpackChunkName: "pais" */ "./generales/Pais.vue"),
  },
  {
    path: "/institucion",
    name: "Institucion",
    component: () =>
      import(
        /* webpackChunkName: "institucion" */ "./generales/institucion/index.vue"
      ),
  },
  {
    path: "/categorias",
    name: "categorias",
    component: () =>
      import(
        /* webpackChunkName: "categorias" */ "./generales/categorias/index.vue"
      ),
  },
  {
    path: "/dependientes",
    name: "dependientes",
    component: () =>
      import(
        /* webpackChunkName: "dependencias" */ "./generales/dependencias/index.vue"
      ),
  },
  {
    path: "/discapacidad",
    name: "Discapacidad",
    component: () =>
      import(
        /* webpackChunkName: "discapacidad" */ "./generales/Discapacidad.vue"
      ),
  },
  {
    path: "/tipo-establecimiento",
    name: "TipoEstablecimiento",
    component: () =>
      import(
        /* webpackChunkName: "tipoEstablecimiento" */ "./generales/TipoEstablecimiento.vue"
      ),
  },
  {
    path: "/establecimiento",
    name: "Establecimiento",
    component: () =>
      import(
        /* webpackChunkName: "establecimiento" */ "./generales/Establecimiento.vue"
      ),
  },
  {
    path: "/departamento",
    name: "Departamento",
    component: () =>
      import(/* webpackChunkName: "pais" */ "./generales/Departamento.vue"),
  },
  {
    path: "/estado-civil",
    name: "EstadoCivil",
    component: () =>
      import(
        /* webpackChunkName: "estadoCivil" */ "./generales/EstadoCivil.vue"
      ),
  },
  {
    path: "/formacion-academica",
    name: "FormacionAcademica",
    component: () =>
      import(
        /* webpackChunkName: "formacionAcademica" */ "./generales/FormacionAcademica.vue"
      ),
  },
  {
    path: "/municipio",
    name: "Municipio",
    component: () =>
      import(/* webpackChunkName: "municipio" */ "./generales/Municipio.vue"),
  },
  {
    path: "/nivel-educativo",
    name: "NivelEducativo",
    component: () =>
      import(
        /* webpackChunkName: "nivelEducativo" */ "./generales/NivelEducativo.vue"
      ),
  },
  {
    path: "/parentesco",
    name: "Parentesco",
    component: () =>
      import(/* webpackChunkName: "parentesco" */ "./generales/Parentesco.vue"),
  },
  {
    path: "/administradora-pensiones",
    name: "AdministradoraPensiones",
    component: () =>
      import(/* webpackChunkName: "parentesco" */ "./generales/AdministradoraPensiones.vue"),
  },
  {
    path: "/tipo-documento",
    name: "TipoDocumento",
    component: () =>
      import(
        /* webpackChunkName: "tipoDocumento" */ "./generales/TipoDocumento.vue"
      ),
  },
  {
    path: "/tipo-institucion",
    name: "TipoInstitucion",
    component: () =>
      import(
        /* webpackChunkName: "tipoInstitucion" */ "./generales/TipoInstitucion.vue"
      ),
  },
  {
    path: "/tipo-sangre",
    name: "TipoSangre",
    component: () =>
      import(/* webpackChunkName: "tipoSangre" */ "./generales/TipoSangre.vue"),
  },
  // rutas nuevas
  {
    path: "/institucion-financiera",
    name: "InstitucionFinanciera",
    component: () =>
      import(
        /* webpackChunkName: "tipoSangre" */ "./generales/InstitucionesFinancieras.vue"
      ),
  },
  {
    path: "/pagaduria",
    name: "Pagaduria",
    component: () =>
      import(/* webpackChunkName: "tipoSangre" */ "./generales/Pagaduria.vue"),
  },
  {
    path: "/tipo-acreedor",
    name: "TipoAcreedor",
    component: () =>
      import(
        /* webpackChunkName: "tipoSangre" */ "./generales/TipoAcreedores.vue"
      ),
  },
  {
    path: "/acreedor",
    name: "Acreedor",
    component: () =>
      import(/* webpackChunkName: "tipoSangre" */ "./generales/Acreedores.vue"),
  },
  {
    path: "/presupuesto-financia",
    name: "PresupuestoFinancia",
    component: () =>
      import(
        /* webpackChunkName: "presupuesto" */ "./catalogosPlaza/PresupuestoFinancia.vue"
      ),
  },
  {
    path: "/tipo-financiamiento",
    name: "TipoFinanciamiento",
    component: () =>
      import(
        /* webpackChunkName: "financiamiento" */ "./catalogosPlaza/TipoFinanciamiento.vue"
      ),
  },
  {
    path: "/estado-plaza",
    name: "EstadoPlaza",
    component: () => import("./catalogosPlaza/EstadoPlazas.vue"),
  },
  {
    path: "/plaza-nominal",
    name: "PlazaNominal",
    component: () => import("./catalogosPlaza/PlazaNominal.vue"),
  },
  {
    path: "/configurador-institucion",
    name: "ConfiguradoresInstitucion",
    component: () => import("../../views/usuariosTitulares/usuarios_titulares.vue"),
    // component: () => import("./generales/ConfiguradoresInstitucion.vue"),
  },
  {
    path: "/especifico-gasto",
    name: "EspecificoGasto",
    component: () => import("./especificoGasto/EspecificoGasto.vue"),
  },
  {
    path: "/cifrado-presupuestario",
    name: "CifradoPresupuestario",
    component: () =>
      import("./cifradoPresupuestario/CifradoPresupuestario.vue"),
  },
  {
    path: '/categoria-descuento',
    name: 'CategoriaDescuentos',
    component: () => import("./categoriaDescuentos/categoriaDescuento.vue")
  },
  {
    path: "/unidad-presupuestaria",
    name: "UnidadPresupuestaria",
    component: () =>
      import(
        /* webpackChunkName: "presupuesto" */ "./unidadPresupuestaria/UnidadPresupuestaria.vue"
      ),
  },
  {
    path: "/fuentes-recursos",
    name: "fuentes-recursos",
    component: () =>
      import(
        /* webpackChunkName: "fuentes-recursos" */ "./generales/fuentesRecursos/mantenimientoFuentesRecursos.vue"
      ),
  },
  {  
    path: "/catalogo/plazas",
    name: "Plazas",
    component: () => import("./generales/plazas/Plaza.vue"),
  },
  {  
    path: "/mantenimiento-usuarios-carga-inicial",
    name: "Usuarios",
    component: () =>
      import(
        /* webpackChunkName: "presupuesto" */ "./usuarios/usuarios.vue"),
  },
  {
    path: '/list-proyectos-inversion-publica',
    name: 'listProyectosInversionPublica',
    component: () =>
      import("./proyectosInversionPublica/views/listProyectosInversionPublicaView.vue")
  },
  {
    path: "/catalogo-agrupadores-operacionales",
    name: "CategoriaAgrupadoresOperacionales",
    component: () =>
      import(
        /* webpackChunkName: "presupuesto" */ "./catalogoAgrupadoresOperacionales/catalogoAgrupadoresOperacionales.vue"
      ),
  },
  {
    path: "/documento-plaza",
    name: "DocumentoPlaza",
    component: () => import( /* webpackChunkName: "documentoPlaza" */ "./documentoPlaza/DocumentoPlaza.vue"),
  },
  {
    path: "/catalogo-funciones",
    name: "funciones",
    component: () =>
      import(
        /* webpackChunkName: "funciones" */ "./funciones/index.vue"
      ),
  },
  {
    path: "/catalogo-evaluaciones",
    name: "catalogo-evaluaciones",
    component: () =>
      import(
        /* webpackChunkName: "catalogo-evaluaciones" */ "./evaluaciones/Evaluaciones.vue"
      ),
  },
  {
    path: "/tipo-plaza",
    name: "TipoPlaza",
    component: () => import("./tipoPlaza/TipoPlaza.vue"),
  },
];
